import { Flex } from 'antd';
import { EvidenceSection, EvidenceSectionNameMap } from 'api/brokerCases/types';
import { ApplicantOption, getProgressFromSection } from 'pages/EvidencePage/helpers';
import { EvidenceListItem } from './components';

export interface IEvidenceListProps {
  sections: EvidenceSection[];
  individuals: ApplicantOption[];
  isCaseTasksLoading: boolean;
}

export const EvidenceList = ({ sections, individuals, isCaseTasksLoading }: IEvidenceListProps) => {
  const orderedSections = [
    ...sections.filter(section => section.name === EvidenceSectionNameMap.FURTHER_INFORMATION_REQUIRED),
    ...sections.filter(
      section =>
        section.name !== EvidenceSectionNameMap.FURTHER_INFORMATION_REQUIRED &&
        section.name !== EvidenceSectionNameMap.OTHER_DOCUMENTS,
    ),
    ...sections.filter(section => section.name === EvidenceSectionNameMap.OTHER_DOCUMENTS),
  ];

  function getSectionWrapperClassName(sectionName: EvidenceSection['name']): string {
    if (sectionName === EvidenceSectionNameMap.FURTHER_INFORMATION_REQUIRED) return 'mb-4';
    if (sectionName === EvidenceSectionNameMap.OTHER_DOCUMENTS) return 'mt-4';

    return '';
  }

  return (
    <Flex vertical className='gap-2 [&>.ant-collapse]:!mb-0'>
      {orderedSections.map(section => (
        <div key={section.name} className={getSectionWrapperClassName(section.name)}>
          <EvidenceListItem
            name={section.name}
            applicants={individuals}
            tasks={section.tasks}
            progress={getProgressFromSection(section)}
            isCaseTasksLoading={isCaseTasksLoading}
          />
        </div>
      ))}
    </Flex>
  );
};
